import { BrowserRouter, Routes, Route } from "react-router-dom";
import SignIn from "./components/SignIn";
import ResetPassword from "./components/SignIn/ResetPassword";
import Layout from "./Layout";
import { routes } from "./routes";
import GeneratePassword from "./components/SignIn/GeneratePassword";
import { QueryClient, QueryClientProvider } from "react-query";


const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        refetchOnReconnect: false,
      },
    },
  });

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<SignIn />} />
            <Route path="/generate" element={<GeneratePassword />} />

            <Route path="/reset-paasword" element={<ResetPassword />} />
            {routes.map((route) => {
              return (
                <Route
                  key={route.id}
                  path={route.path}
                  element={<Layout component={route.component} />}
                />
              );
            })}
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>



    </>
  );
};

export default App;
